import { LoaderCircle } from 'lucide-react'

type LoadingSpinnerProps = {
  stroke?: string
  size?: number
  className?: string
}

export default function LoadingSpinner({
  stroke = 'var(--primary-teal)',
  size = 30,
  className = '',
}: LoadingSpinnerProps) {
  return (
    <LoaderCircle
      className={`animate-spin ${className}`}
      size={size}
      stroke={stroke}
    />
  )
}
